import intl from "react-intl-universal";
import { Redirect } from "react-router-dom";
import { PageHeaderWithBack, StablesQuotesSection } from "../../../Components/Molecules";
import { useAuth } from "../../../Contexts/AuthContext";
import { StablesDepositarContent } from "./StablesDepositarContent";
import { STABLES_HOME_PATH } from "./constants";
import { StablesWalletGate } from "./StablesWalletGate";

export const StablesDepositar = () => {
  const { hasPermission } = useAuth();
  if (!hasPermission("stablesoperate")) {
    return <Redirect to={STABLES_HOME_PATH} />;
  }

  return (
  <div className="w-full">
    <StablesWalletGate>
      <StablesQuotesSection showViewAll={false} />

      <PageHeaderWithBack
        title={intl.get("stables.deposit")}
        subTitle="Selecione o ativo e a rede para depositar stablecoins na sua carteira."
        backTo={STABLES_HOME_PATH}
      />

      <div className="app-card p-4 sm:p-5">
        <StablesDepositarContent isActive />
      </div>
    </StablesWalletGate>
  </div>
  );
};
